<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><strong>DEDICATED TO THE<br/>BRILLIANT CULINARY LEGACY<br/>OF THE AFRICAN PEOPLE<br/>THROUGHOUT THE DIASPORA</strong></p>
<p class="graphic"><img alt="images" src="OEBPS/images/5-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?2d9b7436